import messages from '../../../../messages';

export const DEFAULTS = {
  headline: 'WILLKOMMEN',
  text: '',
  footnote_title: '',
  links: [],
};

const linkItemSchema = (props) => ({
  title: 'Link',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['label', 'href'],
    },
  ],
  properties: {
    label: { title: 'Link-Text', type: 'string' },
    href: {
      title: props.intl.formatMessage(messages.linkItemSchemaGoal),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
      description: props.intl.formatMessage(messages.listingFootnote),
    },
  },
  required: ['label', 'href'],
});

const Schema = (props) => ({
  title: 'FCMH Welcome',
  fieldsets: [
    {
      id: 'default',
      title: 'Inhalt',
      fields: ['headline', 'text', 'footnote_title', 'links'],
    },
  ],
  properties: {
    headline: {
      title: props.intl.formatMessage(messages.headerTitle),
      type: 'string',
      default: DEFAULTS.headline,
    },
    text: {
      title: 'Intro Text',
      widget: 'textarea',
      default: DEFAULTS.text,
    },
    footnote_title: {
      title: props.intl.formatMessage(messages.welcomeFootnoteText),
      type: 'string',
      default: DEFAULTS.footnote_title,
    },
    links: {
      title: 'Links',
      widget: 'object_list',
      schema: linkItemSchema,
      description: props.intl.formatMessage(messages.welcomeFootnoteLinks),
      default: DEFAULTS.links,
    },
  },
  required: [],
});

export default Schema;
